import {
    isTouchDevice,
    getWindowWidth,
    getDeviceType,
    deviceBodyClass,
    getCookie,
    setCookie,
    deleteCookie,
    debounce,
    getOffsetForElements,
} from "./window.helpers";

window.isTouchDevice = isTouchDevice;
window.getWindowWidth = getWindowWidth;
window.get_device_type = getDeviceType;
window.device_body_class = deviceBodyClass;
window.getCookie = getCookie;
window.setCookie = setCookie;
window.deleteCookie = deleteCookie;
window.debounce = debounce;
window.getOffsetForElements = getOffsetForElements;


window.passiveIfSupported = false;

try {
    window.addEventListener(
        "lmTestPassive",
        null,
        Object.defineProperty({}, "passive", {
            get() {
                window.passiveIfSupported = { passive: true };
            },
        })
    );
} catch (err) {}
